import { Drawer } from "antd";
import React, { useContext, useEffect } from "react";
import { useClient } from "../../Context/ClientContext";
import "../../Common/AddPageCommon.css";
import { notificationContext } from "../../Common/Routing/PageRoute";
import { dayjs } from "../../../Utilities/dayjs";
import { useLocation } from "react-router-dom";
import VoucherServices, {
  Party_Tax,
  Voucher_Type,
} from "../../Services/VoucherServices";
import { Utils } from "../../../Utilities/Utils";
import { useUser } from "../../../Context/UserContext";
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  PDFViewer,
  Font,
} from "@react-pdf/renderer";
import { Table, TR, TH, TD } from "@ag-media/react-pdf-table";
import { IAddressDetails } from "../../Services/SettingService";
import { TypeOfAddress } from "../../Services/LedgerService";

Font.register({
  family: "Arial",
  fonts: [
    {
      src: "/fonts/arial.ttf",
    },
    {
      fontStyle: "bold",
      src: "/fonts/arialbd.ttf",
    },
  ],
});

//style
const styles = StyleSheet.create({
  body: {
    fontFamily: "Arial",
    fontSize: "14px",
  },
  mergedMainTDWithBorder: {
    display: "flex",
    flexDirection: "column",
    padding: 0,
    height: "auto",
  },
  mergedMainTD: {
    display: "flex",
    flexDirection: "column",
    padding: 0,
    borderBottom: "none",
  },
  mergedMainTDWithoutTopnBottomBorder: {
    display: "flex",
    flexDirection: "column",
    padding: 0,
    borderBottom: 0,
    borderTop: 0,
  },
  mergedMainRow: {
    display: "flex",
    flexDirection: "row",
    width: "100%",
    justifyContent: "flex-end",
    borderBottom: "none",
    padding: 0,
  },
  mergedMainRowWithoutTopnBottomBorder: {
    display: "flex",
    flexDirection: "row",
    width: "100%",
    justifyContent: "flex-end",
    borderBottom: 0,
    borderTop: 0,
    padding: 0,
  },
  headerStyle: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    lineHeight: "17px",
  },
  SubHeader: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    lineHeight: "20px",
    paddingTop: "10px",
  },
  fontPadding: { padding: "5px 0px", lineHeight: "20px" },
  FooterfontPadding: {
    fontSize: "14px",
    padding: "5px 0px",
    lineHeight: "20px",
    width: "50%",
  },
  FooterStyle: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    fontSize: "14px",
    paddingTop: "50px",
  },
  summaryTableStyleRight: {
    padding: "2px",
    justifyContent: "flex-end",
    // textAlign: "right",
  },
  summaryTableStyleLeft: {
    padding: "2px",
    justifyContent: "flex-start",
    // textAlign: "left",
  },
  summaryTableStyleCenter: {
    padding: "2px",
    justifyContent: "center",
    // textAlign: "center",
  },
  pad_2: { padding: "2px" },
  pageNumbers: {
    bottom: 20,
    position: "absolute",
    left: 0,
    right: 0,
    textAlign: "center",
    fontSize: "10px",
  },
  stripedRow: { backgroundColor: "#ececec" },
});

const ExpIncVocherPDF: React.FC<{
  open: boolean;
  onCancel: any;
  voucherId?: string | undefined;
  //extra
  partyId?: string | undefined;
  type?: Voucher_Type;
}> = (props) => {
  console.log(props);
  const { currentClient, companySettings } = useClient();
  const { getAllIndStates } = useUser();
  const stateOptions: any = getAllIndStates();
  const location = useLocation();
  const { openNotification } = useContext(notificationContext);
  const [loading, setLoading] = React.useState<boolean>(false);
  const [data, setData] = React.useState<any>({});
  console.log("props?.type =>>", props?.type);

  let splitPathInVchType: Voucher_Type;
  if (location.pathname.split("/")[5] === "expenses") {
    splitPathInVchType = Voucher_Type.Expenses;
  } else {
    splitPathInVchType = props?.type!;
  }

  const templeteAddressSelected: IAddressDetails =
    currentClient?.addresses?.find(
      (x) =>
        x.addressName ===
        companySettings?.setting?.templateSettings?.[0]?.companyTS
          ?.defaultAddress
    ) ?? currentClient?.addresses
      ? currentClient?.addresses[0]
      : {
          type: TypeOfAddress.RegisteredAddress,
          addressName: "",
          address: {
            city: "",
            state: -1,
            pincode: "",
            country: "",
            building: "",
            street: "",
            landmark: "",
            district: "",
          },
        };

  useEffect(() => {
    if (props.voucherId) {
      setLoading(true);
      VoucherServices.getVoucharById(
        currentClient?.id!,
        props.voucherId,
        splitPathInVchType
      )
        .then((res: any) => {
          setData({
            date: dayjs(res?.result?.date).format("DD-MM-YYYY"),
            number: res?.result?.number,
            narration: res?.result?.narration,
            effectiveLedger: res?.result?.freightInsLedgers?.filter(
              (led: any) => led.partyOrTax !== Party_Tax.RoundOff
            ),
            partyLedger: res?.result?.partyLedger,
            voucherNetAmount: res?.result?.amountSummary?.totalInvoiceAmount,
            amountInWords: res?.result?.amountSummary.totalInvoiceAmountInWords,
            voucherTitle: res?.result?.voucherTitle,
            isGSTVoucher: res?.result?.isGSTVoucher,
            isStateSame: res?.result?.isStateSame,
            instantPayment: res?.result?.instantPayment,
            payRecVouchers: res?.result?.payRecVouchers,
            amountSummary: res?.result?.amountSummary,
            roundOff: res?.result?.amountSummary?.roundOff,
          });
          setLoading(false);
        })
        .catch((ex: any) => {
          openNotification("error", ex.message);
          setLoading(false);
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentClient?.id, props.voucherId]);

  return (
    <React.Fragment>
      <Drawer
        open={props.open}
        width={"50%"}
        style={{ height: "calc(100%)", overflowY: "auto" }}
        title={<p>Preview</p>}
        onClose={props.onCancel}
        loading={loading}
      >
        <PDFViewer width="100%" height="100%">
          <Document title="Document">
            <Page size="A4" style={{ padding: "10mm 10mm 10mm 15mm" }} wrap>
              <View style={styles.body}>
                {/* Header */}
                <View>
                  <View style={styles.headerStyle}>
                    <div>
                      <Text
                        style={{
                          fontSize: "18px",
                          fontStyle: "bold",
                          lineHeight: "20px",
                        }}
                      >
                        {currentClient?.businessName}
                      </Text>
                      {templeteAddressSelected?.address?.building !== null ? (
                        <div style={{ display: "flex", flexDirection: "row" }}>
                          <Text>
                            {templeteAddressSelected?.address?.building!}
                          </Text>
                          {templeteAddressSelected?.address?.street !== null ? (
                            <>
                              <Text>
                                {", "}
                                {templeteAddressSelected?.address?.street}
                              </Text>
                              <br />
                            </>
                          ) : (
                            ""
                          )}
                        </div>
                      ) : (
                        ""
                      )}
                      {templeteAddressSelected?.address?.landmark !== null ? (
                        <div style={{ display: "flex", flexDirection: "row" }}>
                          <Text>
                            {templeteAddressSelected?.address?.landmark}
                            {", "}
                          </Text>
                        </div>
                      ) : (
                        ""
                      )}
                      {templeteAddressSelected?.address?.city !== null ? (
                        <div style={{ display: "flex", flexDirection: "row" }}>
                          <Text>
                            {templeteAddressSelected?.address?.city}
                            {", "}
                          </Text>
                          {templeteAddressSelected?.address?.district !==
                          null ? (
                            <>
                              <Text>
                                {templeteAddressSelected?.address?.district}
                              </Text>
                            </>
                          ) : (
                            ""
                          )}
                        </div>
                      ) : (
                        ""
                      )}
                      {currentClient?.state ||
                      templeteAddressSelected?.address?.state ? (
                        <div style={{ display: "flex", flexDirection: "row" }}>
                          <Text>
                            <Text style={{ fontStyle: "bold" }}>State: </Text>
                            <Text>
                              {currentClient?.state
                                ? Object.entries(stateOptions)?.map(
                                    ([key, s]: any) =>
                                      s.id === currentClient?.state
                                        ? s.name + ", "
                                        : ""
                                  )
                                : Object.entries(stateOptions)?.map(
                                    ([key, s]: any) =>
                                      s.id ===
                                      templeteAddressSelected?.address?.state
                                        ? s.name + ", "
                                        : ""
                                  )}{" "}
                            </Text>
                            <Text style={{ fontStyle: "bold" }}>Code: </Text>
                            <Text>
                              {currentClient?.state
                                ? currentClient?.state
                                    .toString()
                                    .padStart(2, "0")
                                : templeteAddressSelected?.address?.state
                                    .toString()
                                    .padStart(2, "0")}
                            </Text>
                          </Text>
                          <br />
                        </div>
                      ) : (
                        ""
                      )}
                      {currentClient?.gstin !== null ? (
                        <div style={{ display: "flex", flexDirection: "row" }}>
                          <Text>
                            <Text style={{ fontStyle: "bold" }}>GSTIN: </Text>
                            <Text>{currentClient?.gstin}</Text>
                          </Text>
                          <br />
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                    <div>
                      <Text style={{ fontStyle: "bold", fontSize: "16px" }}>
                        {data?.voucherTitle?.name}
                      </Text>
                    </div>
                  </View>

                  <View style={styles.headerStyle}>
                    <div style={styles.SubHeader}>
                      <div style={styles.fontPadding}>
                        <Text style={{ fontStyle: "bold" }}>
                          Party / Account:{" "}
                        </Text>
                        <Text>
                          {data?.partyLedger &&
                            data?.partyLedger[0]?.ledgerName}
                        </Text>
                      </div>
                    </div>

                    <div style={styles.SubHeader}>
                      <div style={styles.fontPadding}>
                        <div style={{ alignItems: "flex-end" }}>
                          <Text>
                            <Text style={{ fontStyle: "bold" }}>Date: </Text>
                            <Text>{data?.date}</Text>
                          </Text>
                        </div>
                        <div>
                          <Text>
                            <Text style={{ fontStyle: "bold" }}>
                              Voucher No.:{" "}
                            </Text>
                            <Text>{data?.number}</Text>
                          </Text>
                        </div>
                      </div>
                    </div>
                  </View>
                </View>

                {/* Content */}
                <View wrap={false}>
                  <Table
                    style={{
                      marginTop: "5px",
                      border: "1px solid grey",
                      fontSize: 12,
                    }}
                    tdStyle={{ padding: "2px 3px" }}
                    wrap={false}
                  >
                    <TH
                      style={{
                        width: "100%",
                        fontStyle: "bold",
                      }}
                    >
                      <TD weighting={0.05}>S.No</TD>
                      <TD
                        weighting={
                          data?.isGSTVoucher && data?.isStateSame
                            ? 0.4
                            : data?.isGSTVoucher && !data?.isStateSame
                            ? 0.6
                            : 0.8
                        }
                      >
                        {" "}
                        Account(s)
                      </TD>
                      <TD
                        weighting={0.15}
                        style={{ justifyContent: "flex-end" }}
                      >
                        <Text>
                          {data?.isGSTVoucher ? "Taxable Amount" : "Amount"}
                        </Text>
                      </TD>
                      {data?.isGSTVoucher && data?.isStateSame ? (
                        <>
                          <TD weighting={0.2} style={styles.mergedMainTD}>
                            <Text>CGST</Text>
                            <TR style={styles.mergedMainRow}>
                              <TD
                                weighting={0.3}
                                style={{
                                  justifyContent: "center",
                                  marginBottom: 0,
                                }}
                              >
                                Rate
                              </TD>
                              <TD
                                weighting={0.7}
                                style={{
                                  justifyContent: "flex-end",
                                  marginBottom: 0,
                                }}
                              >
                                Amount
                              </TD>
                            </TR>
                          </TD>
                          <TD weighting={0.2} style={styles.mergedMainTD}>
                            <Text>SGST</Text>
                            <TR style={styles.mergedMainRow}>
                              <TD
                                weighting={0.3}
                                style={{
                                  justifyContent: "center",
                                  marginBottom: 0,
                                }}
                              >
                                Rate
                              </TD>
                              <TD
                                weighting={0.7}
                                style={{
                                  justifyContent: "flex-end",
                                  marginBottom: 0,
                                }}
                              >
                                Amount
                              </TD>
                            </TR>
                          </TD>
                        </>
                      ) : data?.isGSTVoucher && !data?.isStateSame ? (
                        <TD weighting={0.2} style={styles.mergedMainTD}>
                          <Text>IGST</Text>
                          <TR style={styles.mergedMainRow}>
                            <TD
                              weighting={0.3}
                              style={{
                                justifyContent: "center",
                                marginBottom: 0,
                              }}
                            >
                              Rate
                            </TD>
                            <TD
                              weighting={0.7}
                              style={{
                                justifyContent: "flex-end",
                                marginBottom: 0,
                              }}
                            >
                              Amount
                            </TD>
                          </TR>
                        </TD>
                      ) : (
                        <></>
                      )}
                    </TH>

                    {data.effectiveLedger?.map((led: any, i: any) => {
                      return (
                        <>
                          <TR key={i} style={{ width: "100%" }}>
                            <TD
                              weighting={0.05}
                              style={{ borderBottom: 0, borderTop: 0 }}
                            >
                              {led.id !== "" ? i + 1 : ""}
                            </TD>
                            <TD
                              weighting={
                                data?.isGSTVoucher && data?.isStateSame
                                  ? 0.4
                                  : data?.isGSTVoucher && !data?.isStateSame
                                  ? 0.6
                                  : 0.8
                              }
                              style={{
                                borderBottom: 0,
                                borderTop: 0,
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "flex-start",
                                alignItems: "flex-start",
                              }}
                            >
                              <Text>{led.ledgerName}</Text>
                              <Text
                                style={{
                                  fontSize: 12,
                                }}
                              >
                                {led?.description}
                              </Text>
                            </TD>
                            <TD
                              weighting={0.15}
                              style={{
                                justifyContent: "flex-end",
                                borderBottom: 0,
                                borderTop: 0,
                              }}
                            >
                              <Text>
                                {led.amount
                                  ? Utils.getFormattedNumber(led.amount)
                                  : " "}
                              </Text>
                            </TD>

                            {data?.isGSTVoucher && data?.isStateSame ? (
                              <>
                                <TD
                                  weighting={0.2}
                                  style={
                                    styles.mergedMainTDWithoutTopnBottomBorder
                                  }
                                >
                                  <TR
                                    style={
                                      styles.mergedMainRowWithoutTopnBottomBorder
                                    }
                                  >
                                    <TD
                                      weighting={0.3}
                                      style={{
                                        justifyContent: "center",
                                        marginBottom: 0,
                                        borderBottom: 0,
                                        borderTop: 0,
                                      }}
                                    >
                                      <Text>
                                        {led?.gstRate?.rate
                                          ? led?.gstRate?.rate / 2
                                          : " "}
                                      </Text>
                                    </TD>
                                    <TD
                                      weighting={0.7}
                                      style={{
                                        justifyContent: "flex-end",
                                        marginBottom: 0,
                                        borderBottom: 0,
                                        borderTop: 0,
                                      }}
                                    >
                                      <Text>
                                        {led?.gstAmount
                                          ? Utils.getFormattedNumber(
                                              led?.gstAmount / 2
                                            )
                                          : " "}
                                      </Text>
                                    </TD>
                                  </TR>
                                </TD>
                                <TD
                                  style={
                                    styles.mergedMainTDWithoutTopnBottomBorder
                                  }
                                  weighting={0.2}
                                >
                                  <TR
                                    style={
                                      styles.mergedMainRowWithoutTopnBottomBorder
                                    }
                                  >
                                    <TD
                                      weighting={0.3}
                                      style={{
                                        justifyContent: "center",
                                        marginBottom: 0,
                                        borderBottom: 0,
                                        borderTop: 0,
                                      }}
                                    >
                                      {led?.gstRate?.rate &&
                                        led?.gstRate?.rate / 2}
                                    </TD>
                                    <TD
                                      weighting={0.7}
                                      style={{
                                        justifyContent: "flex-end",
                                        marginBottom: 0,
                                        borderBottom: 0,
                                        borderTop: 0,
                                      }}
                                    >
                                      {" "}
                                      {led?.gstAmount
                                        ? Utils.getFormattedNumber(
                                            led?.gstAmount / 2
                                          )
                                        : " "}
                                    </TD>
                                  </TR>
                                </TD>
                              </>
                            ) : data?.isGSTVoucher && !data?.isStateSame ? (
                              <TD
                                weighting={0.2}
                                style={
                                  styles.mergedMainTDWithoutTopnBottomBorder
                                }
                              >
                                <TR
                                  style={
                                    styles.mergedMainRowWithoutTopnBottomBorder
                                  }
                                >
                                  <TD
                                    weighting={0.3}
                                    style={{
                                      justifyContent: "center",
                                      marginBottom: 0,
                                      borderBottom: 0,
                                      borderTop: 0,
                                    }}
                                  >
                                    {led?.gstRate?.rate
                                      ? led?.gstRate?.rate / 2
                                      : " "}
                                  </TD>
                                  <TD
                                    weighting={0.7}
                                    style={{
                                      justifyContent: "flex-end",
                                      marginBottom: 0,
                                      borderBottom: 0,
                                      borderTop: 0,
                                    }}
                                  >
                                    {led?.gstAmount
                                      ? Utils.getFormattedNumber(led?.gstAmount)
                                      : " "}
                                  </TD>
                                </TR>
                              </TD>
                            ) : (
                              <></>
                            )}
                          </TR>
                        </>
                      );
                    })}
                    <TR style={{ width: "100%", fontStyle: "bold" }}>
                      <TD weighting={0.05}></TD>
                      <TD
                        weighting={
                          data?.isGSTVoucher && data?.isStateSame
                            ? 0.4
                            : data?.isGSTVoucher && !data?.isStateSame
                            ? 0.6
                            : 0.8
                        }
                        style={{ justifyContent: "flex-end" }}
                      >
                        <Text>Total</Text>
                      </TD>
                      <TD
                        weighting={0.15}
                        style={{ justifyContent: "flex-end" }}
                      >
                        <Text>
                          {Utils.getFormattedNumber(
                            data?.amountSummary?.cifExpenses
                          )}
                        </Text>
                      </TD>
                      {data?.isGSTVoucher && data?.isStateSame ? (
                        <>
                          <TD weighting={0.2} style={styles.mergedMainTD}>
                            <TR style={styles.mergedMainRow}>
                              <TD weighting={0.3}></TD>
                              <TD
                                weighting={0.7}
                                style={{
                                  justifyContent: "flex-end",
                                  marginBottom: 0,
                                }}
                              >
                                {Utils.getFormattedNumber(
                                  data?.amountSummary?.totalCIFGSTAmt / 2
                                )}
                              </TD>
                            </TR>
                          </TD>
                          <TD weighting={0.2} style={styles.mergedMainTD}>
                            <TR style={styles.mergedMainRow}>
                              <TD weighting={0.3}></TD>
                              <TD
                                weighting={0.7}
                                style={{
                                  justifyContent: "flex-end",
                                  marginBottom: 0,
                                }}
                              >
                                {Utils.getFormattedNumber(
                                  data?.amountSummary?.totalCIFGSTAmt / 2
                                )}
                              </TD>
                            </TR>
                          </TD>
                        </>
                      ) : data?.isGSTVoucher && !data?.isStateSame ? (
                        <TD weighting={0.2} style={styles.mergedMainTD}>
                          <TR style={styles.mergedMainRow}>
                            <TD weighting={0.3}></TD>
                            <TD
                              weighting={0.7}
                              style={{
                                justifyContent: "flex-end",
                                marginBottom: 0,
                              }}
                            >
                              {Utils.getFormattedNumber(
                                data?.amountSummary?.totalCIFGSTAmt
                              )}
                            </TD>
                          </TR>
                        </TD>
                      ) : (
                        <></>
                      )}
                    </TR>
                    {/* Gross Amount Detail */}
                    {data?.roundOff?.roundOffAmount !== 0 && (
                      <>
                        {" "}
                        <TR
                          style={{
                            width: "100%",
                            fontStyle: "bold",
                          }}
                        >
                          <TD
                            weighting={data?.isGSTVoucher ? 0.456 : 0.535}
                            style={{
                              justifyContent: "flex-end",
                            }}
                          >
                            Gross Total
                          </TD>
                          <TD style={{ justifyContent: "flex-end" }}>
                            <Text>
                              {Utils.getFormattedNumber(
                                data?.amountSummary?.voucherAmountWithoutTCS
                              )}
                            </Text>
                          </TD>
                        </TR>
                      </>
                    )}

                    {data?.roundOff?.roundOffAmount !== 0 && (
                      <>
                        {" "}
                        <TR
                          style={{
                            width: "100%",
                          }}
                        >
                          <TD
                            weighting={data?.isGSTVoucher ? 0.456 : 0.535}
                            style={{
                              justifyContent: "flex-end",
                            }}
                          >
                            Round Off
                          </TD>
                          <TD style={{ justifyContent: "flex-end" }}>
                            <Text>
                              {Utils.getFormattedNumber(
                                data?.roundOff?.roundOffAmount
                              )}
                            </Text>
                          </TD>
                        </TR>
                      </>
                    )}

                    {data?.cashDiscount && (
                      <>
                        {" "}
                        <TR
                          style={{
                            width: "100%",
                          }}
                        >
                          <TD
                            weighting={data?.isGSTVoucher ? 0.456 : 0.535}
                            style={{
                              justifyContent: "flex-end",
                            }}
                          >
                            Cash Discount
                          </TD>
                          <TD style={{ justifyContent: "flex-end" }}>
                            <Text>
                              {Utils.getFormattedNumber(
                                data?.cashDiscount?.discountAmount
                              )}
                            </Text>
                          </TD>
                        </TR>
                      </>
                    )}

                    <TR
                      style={{
                        width: "100%",
                        fontSize: 14,
                        fontStyle: "bold",
                      }}
                    >
                      <TD
                        weighting={data?.isGSTVoucher ? 0.456 : 0.535}
                        style={{
                          justifyContent: "flex-end",
                        }}
                      >
                        Total Value
                      </TD>
                      <TD style={{ justifyContent: "flex-end" }}>
                        <Text>
                          ₹{Utils.getFormattedNumber(data.voucherNetAmount)}
                        </Text>
                      </TD>
                    </TR>
                    <TR style={{ width: "100%" }}>
                      <TD
                        style={{
                          display: "flex",
                          flexDirection: "row",
                        }}
                      >
                        <Text
                          style={{
                            fontStyle: "bold",
                          }}
                        >
                          Amount (in words):
                        </Text>
                        <Text>
                          {" INR "}
                          {data.amountInWords}
                        </Text>
                      </TD>
                    </TR>
                  </Table>
                </View>

                {/* Footer */}
                <View>
                  <div style={styles.headerStyle}>
                    <div style={styles.FooterfontPadding}>
                      <Text style={{ fontStyle: "bold", marginTop: "5px" }}>
                        Description:
                      </Text>
                      <Text style={{ fontSize: "12px", lineHeight: "14px" }}>
                        {data?.narration}
                      </Text>
                    </div>
                  </div>
                  {data?.instantPayment && (
                    <div style={{ width: "60%", fontSize: 12 }}>
                      <div>
                        <Text style={{ marginBottom: "2px" }}>
                          {splitPathInVchType === Voucher_Type.Expenses
                            ? "Payment made by: "
                            : "Amount received in: "}
                        </Text>
                      </div>
                      <Table
                        wrap={false}
                        tdStyle={{ padding: "2px" }}
                        style={{
                          paddingBottom: "5px",
                          width: "100%",
                          border: "1px solid grey",
                        }}
                      >
                        <TH
                          style={{
                            fontStyle: "bold",
                          }}
                        >
                          <TD
                            style={styles.summaryTableStyleLeft}
                            weighting={0.4}
                          >
                            Account Name
                          </TD>
                          <TD
                            style={styles.summaryTableStyleCenter}
                            weighting={0.3}
                          >
                            Voucher No.
                          </TD>
                          <TD
                            style={styles.summaryTableStyleRight}
                            weighting={0.3}
                          >
                            Amount
                          </TD>
                        </TH>
                        {data?.payRecVouchers?.map((vch: any) => (
                          <TR>
                            <TD
                              style={styles.summaryTableStyleLeft}
                              weighting={0.4}
                            >
                              {vch.effectiveLedger[0].ledgerName}
                            </TD>
                            <TD
                              style={styles.summaryTableStyleCenter}
                              weighting={0.3}
                            >
                              {vch.number}
                            </TD>
                            <TD
                              style={styles.summaryTableStyleRight}
                              weighting={0.3}
                            >
                              {Utils.getFormattedNumber(
                                Math.abs(vch.effectiveLedger[0].amount)
                              )}
                            </TD>
                          </TR>
                        ))}
                        <TH
                          style={{
                            fontStyle: "bold",
                          }}
                        >
                          <TD
                            style={styles.summaryTableStyleLeft}
                            weighting={0.4}
                          >
                            Total Amount
                          </TD>
                          <TD
                            style={styles.summaryTableStyleCenter}
                            weighting={0.3}
                          ></TD>
                          <TD
                            style={styles.summaryTableStyleRight}
                            weighting={0.3}
                          >
                            {Utils.getFormattedNumber(
                              Math.abs(
                                data?.payRecVouchers?.reduce(
                                  (acc: any, rec: any) =>
                                    acc +
                                    (rec?.amountSummary?.totalInvoiceAmount > 0
                                      ? rec?.amountSummary?.totalInvoiceAmount
                                      : 0),
                                  0
                                )
                              )
                            )}
                          </TD>
                        </TH>
                      </Table>
                    </div>
                  )}
                  <div style={styles.FooterStyle}>
                    <Text style={{ fontStyle: "bold" }}>Prepared by</Text>
                    <Text style={{ fontStyle: "bold" }}>Checked by</Text>
                    <Text style={{ fontStyle: "bold" }}>
                      Authorized Signatory
                    </Text>
                  </div>
                </View>

                {/* Page Numbers */}

                <Text
                  style={styles.pageNumbers}
                  render={({ pageNumber, totalPages }) =>
                    pageNumber === 1 ? " " : `${pageNumber} / ${totalPages}`
                  }
                  fixed
                />
              </View>
            </Page>
          </Document>
        </PDFViewer>
      </Drawer>
    </React.Fragment>
  );
};
export default ExpIncVocherPDF;
